import React from 'react'
import { ChevronDown, ChevronUp } from 'baseui/icon'
import { styled } from 'baseui'

// eslint-disable-next-line react/prop-types
export const CustomToggleIcon = function ({ $expanded, $style, ...restProps }) {
  const mergedStyle = Object.assign({}, $style, {
    width: '2rem',
    height: '2rem',
    color: '#808284',
  })
  return $expanded
    ? React.createElement(ChevronUp, Object.assign({}, restProps, { style: mergedStyle }))
    : React.createElement(ChevronDown, Object.assign({}, restProps, { style: mergedStyle }))
}

export const StyledContainer = styled('div', () => ({
  width: '100%',
  padding: '0rem',
  paddingBottom: '0.4rem',
}))

export const HeaderContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
})

export const StyledTitle = styled('h3', () => ({
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  fontWeight: '600',
  fontSize: '1.125rem',
  lineHeight: '160%',
  color: '#343535',
}))

export const TimelineContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  padding: '0 0 0 1.5rem',
})

export const TimelineLine = styled('div', ({ $last, $height }) => ({
  position: 'absolute',
  left: '0.53rem',
  width: '0.225rem',
  backgroundColor: '#A9ABAE',
  top: '1.65rem',
  height: $height || 'auto',
  bottom: $last ? '0' : '3rem',
}))

export const TimelineDateGroup = styled('div', {
  position: 'relative',
  padding: '1rem 0 0.5rem 0',
  '::before': {
    content: '""',
    position: 'absolute',
    left: '-1.5rem',
    top: '1.25rem',
    width: '1.25rem',
    height: '1.25rem',
    borderRadius: '50%',
    backgroundColor: 'white',
    border: '0.125rem solid #B0B0B0',
  },
  '::after': {
    content: '""',
    position: 'absolute',
    left: '-1.125rem',
    top: '1.625rem',
    width: '0.5rem',
    height: '0.5rem',
    borderRadius: '50%',
    backgroundColor: '#B0B0B0',
  },
})

export const TimelineDate = styled('div', {
  position: 'relative',
  fontSize: '.94rem',
  color: '#343535',
  marginTop: '0.25rem',
  paddingLeft: '0.5rem',
})

export const ContractsList = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const ContractItem = styled('div', {
  display: 'flex',
  alignItems: 'center',
  padding: '0.1rem 0.1rem',
  cursor: 'pointer',
})

export const ContractType = styled('span', {
  display: 'flex',
  alignItems: 'center',
  color: '#58595B',
})

export const ContractPrestationType = styled('span', {
  fontSize: '0.75rem',
  color: '#666666',
  marginLeft: 'auto',
  padding: '0.1875rem 0.5rem',
  backgroundColor: '#E5E5E5',
  borderRadius: '0.75rem',
  fontWeight: 500,
  alignSelf: 'center',
})

export const IconWrapper = styled('span', {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: '1',
  marginRight: '0.1rem',
})

export const StyledTopContainerEmpty = styled('div', () => ({
  padding: '1rem',
}))

export const StyledHeaderEmpty = styled('div', () => ({}))

export const StyledEmptyMessageContainer = styled('div', () => ({
  display: 'flex',
  alignItems: 'center',
  padding: '0rem 0.5rem 1rem 1rem',
}))

export const StyledEmptyIcon = styled('img', () => ({
  width: 'auto',
}))

export const StyledEmptyText = styled('span', () => ({
  paddingTop: '0.45rem',
  color: '#58595B',
}))
